import React from 'react';
import Post from "../../components/Post/Post";

const PostPage = () => {
    return (
        <Post/>
    );
};

export default PostPage;
